<template>
  <div v-if="group" class="group-details">
    <div>
      <div
        v-if="group.cover"
        class="cover"
        v-lazy:background-image="group.cover.url"
      ></div>
    </div>
    <div class="container section">
      <div class="columns">
        <div class="column">
          <group-header :group="group" />
        </div>
        <div class="column is-one-third"></div>
      </div>

      <div class="columns tw-mt-12">
        <div class="column">
          <div>
            <div class="section-block">
              <span class="title">NOTICEBOARD</span>
            </div>

            <promised
              :promise="noticePromise"
              v-slot:combined="{ isPending, data }"
            >
              <skeleton-loading v-if="isPending" />
              <template v-else-if="data">
                <noticeboard-card
                  class="tw-rounded tw-border-none"
                  style="background-color: #f2f2f6;"
                  :notice="notice"
                  :key="notice.id"
                  v-for="notice in data.data"
                />

                <b-pagination
                  class="tw-mt-8"
                  v-if="data.meta.last_page > 1"
                  @change="onPageChanged"
                  :total="data.meta.total"
                  :current.sync="data.meta.current_page"
                  :per-page="data.meta.per_page"
                  order="is-centered"
                  aria-next-label="Next page"
                  aria-previous-label="Previous page"
                >
                </b-pagination>
              </template>
            </promised>
          </div>
        </div>
        <div class="column is-one-third">
          <div class="section-block">
            <span class="title">POST A NOTICE</span>
          </div>
          <validation-observer
            @submit.prevent="submitNotice"
            tag="form"
            ref="notice"
            v-slot="{ valid }"
          >
            <validation-provider
              vid="notice"
              rules="required|min:50|max:1500"
              name="notice"
              v-slot="{ errors }"
            >
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input
                  v-model="form.notice"
                  rows="10"
                  type="textarea"
                  placeholder="Write something..."
                >
                </b-input>
              </b-field>
            </validation-provider>
            <b-button
              :disabled="!valid || submitting"
              :loading="submitting"
              class="is-fullwidth"
              native-type="submit"
              type="is-primary"
            >
              Post Notice
            </b-button>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GroupHeader from '@/components/GroupHeader'
import NoticeboardCard from '@/components/NoticeboardCard'
import Notice from '@/models/Notice'

export default {
  metaInfo() {
    if (this.group) {
      return {
        title: this.group.name,
        titleTemplate: 'Noticeboard | %s'
      }
    }
  },
  components: {
    GroupHeader,
    NoticeboardCard
  },
  mounted() {
    this.getGroupNotices()
  },
  data() {
    return {
      submitting: false,
      noticePromise: null,
      form: {
        notice: ''
      },
      noticeMeta: {
        current_page: 1
      }
    }
  },
  computed: {
    ...mapState({
      group: state => state.currentGroup
    })
  },
  methods: {
    getGroupNotices() {
      this.noticePromise = this.group
        .notices()
        .page(this.noticeMeta.current_page)
        .limit(10)
        .include('user')
        .get()
    },
    submitNotice() {
      this.submitting = true
      const notice = new Notice(this.form).for(this.group)
      notice
        .save()
        .then(this.getGroupNotices)
        .then(response => {
          this.form.notice = ''
          requestAnimationFrame(() => {
            this.$refs.notice.reset()
          })
          this.noticeMeta.current_page = 1
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.notice.setErrors(response.data.errors)
          }
        })
        .then(() => {
          this.submitting = false
        })
    },
    onPageChanged(page) {
      this.noticeMeta.current_page = page
      this.getGroupNotices()
    }
  }
}
</script>
